<template>
  <a class="header__favorites order-6" :href="route">
    <span class="header__counter header__favorites-counter" v-if="list.length">{{list.length}}</span>
  </a>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['route'],
  name: 'FavoriteHeaderButton',
  computed: {
    ...mapGetters('favorite', ['list'])
  }
}
</script>

<style scoped>

</style>
